import { Vector3 } from "../Maths/math.vector.js";
/**
 * A cursor which tracks a point on a path
 */
var PathCursor = /** @class */ (function () {
    /**
     * Initializes the path cursor
     * @param _path The path to track
     */
    function PathCursor(_path) {
        this._path = _path;
        /**
         * Stores path cursor callbacks for when an onchange event is triggered
         */
        this._onchange = new Array();
        /**
         * The value of the path cursor
         */
        this.value = 0;
        /**
         * The animation array of the path cursor
         */
        this.animations = new Array();
    }
    /**
     * Gets the cursor point on the path
     * @returns A point on the path cursor at the cursor location
     */
    PathCursor.prototype.getPoint = function () {
        var point = this._path.getPointAtLengthPosition(this.value);
        return new Vector3(point.x, 0, point.y);
    };
    /**
     * Moves the cursor ahead by the step amount
     * @param step The amount to move the cursor forward
     * @returns This path cursor
     */
    PathCursor.prototype.moveAhead = function (step) {
        if (step === void 0) { step = 0.002; }
        this.move(step);
        return this;
    };
    /**
     * Moves the cursor behind by the step amount
     * @param step The amount to move the cursor back
     * @returns This path cursor
     */
    PathCursor.prototype.moveBack = function (step) {
        if (step === void 0) { step = 0.002; }
        this.move(-step);
        return this;
    };
    /**
     * Moves the cursor by the step amount
     * If the step amount is greater than one, an exception is thrown
     * @param step The amount to move the cursor
     * @returns This path cursor
     */
    PathCursor.prototype.move = function (step) {
        if (Math.abs(step) > 1) {
            throw "step size should be less than 1.";
        }
        this.value += step;
        this._ensureLimits();
        this._raiseOnChange();
        return this;
    };
    /**
     * Ensures that the value is limited between zero and one
     * @returns This path cursor
     */
    PathCursor.prototype._ensureLimits = function () {
        while (this.value > 1) {
            this.value -= 1;
        }
        while (this.value < 0) {
            this.value += 1;
        }
        return this;
    };
    /**
     * Runs onchange callbacks on change (used by the animation engine)
     * @returns This path cursor
     */
    PathCursor.prototype._raiseOnChange = function () {
        var _this = this;
        this._onchange.forEach(function (f) { return f(_this); });
        return this;
    };
    /**
     * Executes a function on change
     * @param f A path cursor onchange callback
     * @returns This path cursor
     */
    PathCursor.prototype.onchange = function (f) {
        this._onchange.push(f);
        return this;
    };
    return PathCursor;
}());
export { PathCursor };
//# sourceMappingURL=pathCursor.js.map